import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import { convertDateWithValidation } from "../../helper/losDataHelper";

const BankDetails = ({ bankDetails }) => {

    const bankDetailsColumns = [
        {
            field: "bankAccountNum",
            headerName: "Bank Account Number",
            headerAlign: "center",
            align: "center",
            flex: 200,
            type: "string",
            editable: false,
          },
            {
              field: "internalApplicationId",
              headerName: "Internal Application ID",
              headerAlign: "center",
              align: "center",
              flex: 200,
              type: "string",
              editable: false,
            },
            {
                field: "applicationNum",
                headerName: "Application Number",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "accHoldrName",
                headerName: "Account Holder Name",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "internalBankDetailsId",
                headerName: "Internal Bank Details ID",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "bankCode",
                headerName: "Bank Code",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "branchCode",
                headerName: "Branch Code",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "internalCustomerId",
                headerName: "Internal Customer ID",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "bankAccountType",
                headerName: "Bank Account Type",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "isPrimaryAccount",
                headerName: "Is Primary Account",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "bankBranchName",
                headerName: "Bank Branch Name",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "bankName",
                headerName: "Bank Name",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "dateOfOpening",
                headerName: "Date Of Opening",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => convertDateWithValidation(params.row.dateOfOpening)
              },
              {
                field: "numberOfChequeReturns",
                headerName: "Number Of Cheque Returns",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "averageBankBalance",
                headerName: "Average Bank Balance",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "micrCode",
                headerName: "MICR Code",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "ifscCode",
                headerName: "IFSC Code",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "remarks",
                headerName: "Remarks",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "createdBy",
                headerName: "Created By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "modifiedBy",
                headerName: "Modified By",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
              },
              {
                field: "createdDate",
                headerName: "Created Date",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => convertDateWithValidation(params.row.createdDate)
              },
              {
                field: "modifiedDate",
                headerName: "Modified Date",
                headerAlign: "center",
                align: "center",
                flex: 200,
                type: "string",
                editable: false,
                valueGetter: (params) => convertDateWithValidation(params.row.modifiedDate)
              }
    ];

    return(<>
         <AccordianContainer
          id="accord"
          title="Bank Details"
          initialOpen={false}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
          <CustomDataGrid
            noDataMessage="No Data"
            rows={(bankDetails !== undefined && bankDetails !== null) ?
              bankDetails.map((item, index) => ({
                id: index + 1,
                ...item,
              })) : []}
            columns={bankDetailsColumns}
            pageSize={15}
            pageSizeOptions={[10]}
            gridLazyLoad={() => {}}
            gridHeight={305}
            getRowId={(row) => row.bankAccountNum}
            onCellKeyDown={(event, param) => {
              (param.key === "e" || param.key === "E") &&
                param.preventDefault();
            }}
          />
          </Box>
          </AccordianContainer>
    </>);
}

export default BankDetails;